var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-2{stroke:#fff;stroke-width:2px;fill:none;stroke-linecap:round}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_805",
    "data-name": "Group 805",
    transform: "translate(-926 -54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Ellipse_29",
    fill: "rgba(78,78,87,0.53)",
    stroke: "#fff",
    strokeWidth: "2px",
    "data-name": "Ellipse 29",
    transform: "translate(926 54)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 34.5,
    r: 34.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 34.5,
    r: 33.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_380",
    "data-name": "Group 380",
    transform: "translate(748.5 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line_87",
    d: "M0 0L14 14",
    className: "prefix__cls-2",
    "data-name": "Line 87",
    transform: "translate(205.5 86.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line_88",
    d: "M14 0L0 14",
    className: "prefix__cls-2",
    "data-name": "Line 88",
    transform: "translate(205.5 86.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginXIcon);
export default __webpack_public_path__ + "static/media/login-x-icon.adbe1f214fd6e2b8fb87674f74d02696.svg";
export { ForwardRef as ReactComponent };